import { lazy } from 'react'

export const SubscriptionsVariant3 = lazy(
  () => import('./SubscriptionsVariant3'),
)
